import ResultsByPreferenceCarousel from "@/components/ResultsByPreferenceCarousel";
import { useAppSelector } from "@/utils/hooks/reactUseCustomHooks";
import { GlobalSearchSectionsType } from "@/utils/types/algolia";
import { ArticleType } from "@/utils/types/article";
import { Product } from "@/utils/types/product";
import { RecipeType } from "@/utils/types/recipes";
import React from "react";

const DietaryPreferenceCarousel = React.memo(
  ({
    type,
    preferredResults,
  }: {
    type: GlobalSearchSectionsType;
    preferredResults: Product[] | RecipeType[] | ArticleType[];
  }) => {
    const hitsPerPage = type === "products" ? 15 : 12;

    const { resultsPage } = useAppSelector(
      (state) => state.aemStaticSearchData
    );
    return (
      <>
        {preferredResults?.length > 0 ? (
          <ResultsByPreferenceCarousel
            title={
              resultsPage?.preferenceBasedCarouselTitle ??
              "Based on Your Dietary Preferences"
            }
            type={type}
            items={preferredResults}
            slideCount={hitsPerPage}
          />
        ) : null}
      </>
    );
  }
);

export default DietaryPreferenceCarousel;
